import React, { useContext, useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { PatientContext } from '../../../../contexts';
import TermsLabel from '../../../../components/TermsLabel';

export default function AcceptTermsOfUse({ label, onAcceptChange }) {
  const [checked, setChecked] = useState(false);
  const { settings } = useContext(PatientContext)
  const { loginButton } = settings

const handleCheckboxClick = () => {
  const newChecked = !checked;
  setChecked(newChecked);
  onAcceptChange(newChecked);
};

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={handleCheckboxClick}
          inputProps={{ 'aria-label': 'controlled' }}
          size='small'
          sx={{
            width: '10px',
            height: '10px',
            '&.MuiButtonBase-root.MuiCheckbox-root': {
              color: '#DDE5EC',
              marginRight: 0,            
              '&.Mui-checked': {
                color: loginButton ? loginButton.backgroundColor : '#0166FF'
              },
            },
          }}
        />
      }
      label={
        <div
          style={{
            position: 'relative',
          }}
        >
          <TermsLabel label={label} />
        </div>
      }
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'default',
        '&.MuiFormControlLabel-root': {
          marginRight: 0,
          marginLeft: 0,
          padding: '4px 4px 4px 4px',
        },
        '.MuiTypography-root': {
          color: 'rgb(139, 152, 163)',
          fontWeight: 400,
          fontSize: '10px',  
          marginLeft: '8px',
          whiteSpace: 'pre-wrap',
        },
      }}
    />
  );
}  